import {register} from '@shopify/theme-sections';
import Swiper, { Navigation } from "swiper";

const selectors = {
  target: '.collection-list--',
};

register('collection-list', {

  onLoad() {
    this.init();
  },

  init() {
    this.cleanSlide(this.id);
  },

  cleanSlide(id) {
    const target = `${selectors.target}${id}`;
    const targetSelector = document.querySelector(target);

    if (!targetSelector) { return; }

    Swiper.use([Navigation]);
    const desktopItemsCount = targetSelector.dataset.desktopItemsRow;
    const mobileItemsCount = targetSelector.dataset.mobileItemsRow;
    const swiper = new Swiper(target, {
      slidesPerView: 3,
      loop: true,
      freeMode: false,
      spaceBetween: 0,
      navigation: {
        nextEl: `.swiper-button-next--${id}`,
        prevEl: `.swiper-button-prev--${id}`,
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: mobileItemsCount,
        },
        700: {
          slidesPerView: 2,
        },
        900: {
          slidesPerView: desktopItemsCount,
        }
      }
    });
  },

  onBlockSelect: (blockId) => {
    const id = blockId.detail.sectionId;
    const currentSlide = parseInt(blockId.target.dataset.swiperSlideIndex) + 1;
    const target = `${selectors.target}${id}`;
    const swiper = document.querySelector(target).swiper;
    swiper.slideTo(currentSlide, 1000, false);

    console.log(`🤠 Slide to block ${currentSlide}`)
  },
});
